class StaticClassifierRepository {
  movingDirections = {};
  cameraEventSuspiciousStatuses = {};

  constructor() {
    this.movingDirections = { 0: "Undefined", 1: "In", 2: "Out" };
    this.cameraEventSuspiciousStatuses = {
      1: "Unknown camera",
      2: "Unknown parking zone",
      10: "Undefined direction",
      15: "Number plate",
      20: "IN:IN",
      21: "OUT:OUT",
      22: "No IN",
      30: "Duplicate within same camera set",
    };
  }

  getAllMovingDirections() {
    return Object.keys(this.movingDirections).map((item) => {
      return { id: item, name: this.movingDirections[item] };
    });
  }

  getMovingDirectionNameById(id) {
    return this.movingDirections[id];
  }

  getAllCameraEventSuspiciousStatuses() {
    return Object.keys(this.cameraEventSuspiciousStatuses).map((item) => {
      return { id: item, name: this.cameraEventSuspiciousStatuses[item] };
    });
  }

  getCameraEventSuspiciousStatusNameById(id) {
    return this.cameraEventSuspiciousStatuses[id];
  }
}

export default StaticClassifierRepository;
